export default __webpack_public_path__ + "static/media/point.da84144d.svg";